<div class="communications-container">
  <!-- Panel de filtros avanzados -->
  <div class="filters-panel mb-3">
    <p-panel header="Filtros Avanzados" [toggleable]="true" [collapsed]="false">
      <div class="grid">
        <!-- Filtro por Canal -->
        <div class="col-12 md:col-4">
          <label for="channelFilter">Canal</label>
          <p-multiSelect 
            id="channelFilter"
            [(ngModel)]="channelFilter"
            [options]="channelOptions"
            optionLabel="label"
            optionValue="value"
            placeholder="Todos los canales"
            [style]="{ width: '100%' }"
            (onChange)="applyFilters()"
          ></p-multiSelect>
        </div>
        
        <!-- Filtro por Estado -->
        <div class="col-12 md:col-4">
          <label for="statusFilter">Estado</label>
          <p-multiSelect 
            id="statusFilter"
            [(ngModel)]="statusFilter"
            [options]="statusOptions"
            optionLabel="label"
            optionValue="value"
            placeholder="Todos los estados"
            [style]="{ width: '100%' }"
            (onChange)="applyFilters()"
          ></p-multiSelect>
        </div>
        
        <!-- Filtro por Rango de Fechas -->
        <div class="col-12 md:col-4">
          <label for="dateRangeFilter">Rango de Fechas</label>
          <p-calendar 
            id="dateRangeFilter"
            [(ngModel)]="dateRangeFilter"
            selectionMode="range"
            [readonlyInput]="true"
            placeholder="Seleccionar rango"
            dateFormat="dd/mm/yy"
            [style]="{ width: '100%' }"
            (onSelect)="applyFilters()"
          ></p-calendar>
        </div>
      </div>
      
      <div class="mt-3">
        <button 
          pButton 
          label="Limpiar Filtros" 
          icon="fa-solid fa-times"
          class="p-button-outlined p-button-secondary"
          (click)="clearFilters()"
        ></button>
      </div>
    </p-panel>
  </div>

  <!-- Tabla de comunicaciones -->
  <p-card>
    <div class="row">
      <div class="col-12">
        <h1 class="mb-3">Historial de Comunicaciones</h1>
        <p class="mb-3 text-color-secondary">
          Consulta el registro completo de emails enviados con tracking detallado. 
          Filtra por canal, estado, fechas y lease para analizar la efectividad 
          de las comunicaciones (enviado, entregado, abierto, clicks).
        </p>
      </div>
    </div>

    <!-- Error State -->
    <div *ngIf="hasError" class="error-container">
      <div class="error-content">
        <i class="fa-solid fa-exclamation-triangle error-icon"></i>
        <h3>Oops! Algo salió mal</h3>
        <p>{{ errorMessage }}</p>
        <button pButton label="Reintentar" icon="pi pi-refresh" (click)="retry()"></button>
      </div>
    </div>

    <!-- Content -->
    <app-main-table *ngIf="!hasError"
      [columns]="columns"
      [actions]="actions"
      [apiService]="apiCommunicationsService"
      (onAction)="handleTableAction($event)"
    ></app-main-table>
  </p-card>

  <!-- Dialog: Detalle de Email -->
  <app-email-detail></app-email-detail>

  <!-- Dialog: Preview HTML -->
  <app-email-preview></app-email-preview>

  <!-- Dialog: Tracking Timeline -->
  <app-tracking-timeline></app-tracking-timeline>

  <!-- Toast para notificaciones -->
  <p-toast></p-toast>

  <!-- Dialog de confirmación -->
  <p-confirmDialog></p-confirmDialog>
</div>
